import { render } from "./Width.vue?vue&type=template&id=6f207a8e"
import script from "./Width.vue?vue&type=script&lang=js"
export * from "./Width.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__